// src/services/DisplayService.js
//
// Which countries the hallway display rotates through.
//
// Only exceptions are stored. A country absent from the settings is shown, so a
// new office appearing in Entra reaches the wall without anyone enabling it.
// Switching one off is the deliberate act.

import apiClient from './apiClient'

export async function getDisplayCountries() {
  const response = await apiClient.post('/GetDisplayCountries', {})

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read display settings')
  }

  // Keyed by country. The value used to be a bare boolean; it is now the whole
  // setting, because the rotation interval lives on the same row and callers
  // reading one usually want the other.
  const map = {}
  for (const row of response.data.countries ?? []) {
    map[row.country_code] = {
      enabled: row.enabled !== false,
      rotateSeconds: row.rotate_seconds ?? 30
    }
  }
  return map
}

export async function setDisplayCountry(countryCode, enabled, rotateSeconds = 30) {
  const response = await apiClient.post('/SetDisplayCountry', {
    country_code: countryCode,
    enabled,
    rotate_seconds: rotateSeconds
  })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not save the setting')
  }
}

/** Absent means shown: a country nobody has configured is on by default. */
export function isEnabled(map, countryCode) {
  const setting = map[countryCode]
  if (setting === undefined) return true
  return setting.enabled !== false
}

/** How long this country holds the screen, in seconds. */
export function rotateSecondsFor(map, countryCode, fallback = 30) {
  return map[countryCode]?.rotateSeconds ?? fallback
}
